import {notification} from "antd";
import secureLocalStorage from "react-secure-storage";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import * as XLSX from "xlsx";

export function showMessage(type, message, title) {
    if (type === 'success'){
        notification.success({
            placement:'topRight',
            message: title ? title : 'Success',
            description: message
        })
    }else{
        notification.error({
            placement:'topRight',
            message: title ? title : 'Error',
            description: message
        })
    }

}

export function notifyUser(
    type = "success",
    message,
    title = "Notification",
    placement = "topRight"
) {
    if (type === "error") {
        notification.error({
            message: title,
            description: message,
            placement: placement,
        });
    } else {
        notification.success({
            message: title,
            description: message,
            placement: placement,
        });
    }
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

export const getUserToken = () => secureLocalStorage.getItem('token')

export const getUserDetail = () => JSON.parse(secureLocalStorage.getItem('user'))

export let currencyFormatter = (num) => {
    let split = "";
    if (num) {
        split = parseFloat(num).toFixed(2).toString().split(".");
        split[0] = split[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        split = split.join(".");

        return split === 0 ? 0 : split;
    }else{
        return 0;
    }
};

export const logout = () => {
    secureLocalStorage.removeItem('token');
    secureLocalStorage.removeItem('user');
    secureLocalStorage.removeItem('expiresAt');
}

export let isFormComplete = (form) => {
    return Object.values(form).every(value => value.trim() !== '');
};

export let isFormCompleteIgnore = (form, ignoreField) => {
    // Ghana Card Number is now required, so do not ignore it
    return Object.entries(form)
      .filter(([key]) => key !== ignoreField)
      .every(([key, value]) => value !== '' && value !== null && value !== undefined);
};

// New function for beneficiary validation - makes ID fields optional
export let isBeneficiaryFormValid = (beneficiary) => {
    const requiredFields = ['firstName', 'otherNames', 'relationship', 'dateOfBirth', 'mobileNumber', 'percentageAllocation'];
    return requiredFields.every(field => {
        const value = beneficiary[field];
        return value !== '' && value !== null && value !== undefined && value !== 0;
    });
};

export let isPercentageValid = (beneficiaries) => {
    const totalPercentage = beneficiaries.reduce((sum, beneficiary) => sum + Number(beneficiary.percentageAllocation), 0);
    return totalPercentage === 100;
};

export const logoutUser = () => {
    secureLocalStorage.removeItem('token');
    secureLocalStorage.removeItem('user');
    secureLocalStorage.removeItem('expiresAt');
    window.location.href = '/onboard/login'
}

export const exportToPDF = (columns, data, documentTitle,landscape = false) => {
    const orientation = landscape ? "l" : "p"; // "l" for landscape, "p" for portrait
    const doc = new jsPDF({ orientation });
    const tableColumn = columns.map(col => col.title);
    const tableRows = data.map(item => columns.map(col => item[col.dataIndex]));

    doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        margin: { top: 20, right: 10, bottom: 20, left: 10 },
        styles: { fontSize: 9, cellPadding: 2 },
        pageBreak: 'auto',
        didDrawPage: (data) => {
          // Remove accidental extra space at the end
          doc.setLineWidth(0);
        }
    });

    // Remove any trailing blank pages (jsPDF workaround)
    while (doc.internal.getNumberOfPages() > 1 && doc.internal.pages[doc.internal.getNumberOfPages()].length === 1) {
      doc.deletePage(doc.internal.getNumberOfPages());
    }

    doc.save(`${documentTitle}.pdf`);
}

export const exportToCSV = (data, documentTitle) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, documentTitle);
    XLSX.writeFile(workbook, `${documentTitle}.csv`);
};

export const validateGhanaCard = (value) => {
    const GhanaCardPattern = /^GHA-\d{9}-\d$/;
    return GhanaCardPattern.test(value);
}

export function isValidGhanaianNumber(phone) {
    // Accept both +233 and 233 formats, followed by 9 digits
    const regex = /^(\+233|233)\d{9}$/;
    return regex.test(phone);
}

export function validateMultiIdentity(idType, idNumber) {
    let pattern;
    let errorMessage = "";
    
    if (idType === 'NATIONAL_ID') {
        pattern = /^GHA-\d{9}-\d$/;
        errorMessage = "Ghana Card must be in the format GHA-XXXXXXXXX-X";
    } else if (idType === 'PASSPORT') {
        pattern = /^[A-Z]\d{7}$/; // 1 letter + 7 digits (e.g., G2533349)
        errorMessage = "Passport must start with a letter followed by exactly 7 digits";
    } else if (idType === 'VOTER_ID') {
        pattern = /^\d{10}$/; // Exactly 10 digits
        errorMessage = "Voter ID must be exactly 10 digits";
    } else {
        return {
            success: false,
            error: "Invalid ID type provided"
        };
    }

    if (pattern.test(idNumber)) {
        return {
            success: true,
            message: "ID is valid"
        };
    } else {
        return {
            success: false,
            error: errorMessage
        };
    }
}